"use client";

import Link from "next/link";
import { Icon } from "@iconify/react";
import { useTranslations } from "next-intl";

export type PrimaryButtonProps = {
  text?: string; // Optionnel maintenant
  translationKey?: string; // Nouvelle prop pour la clé de traduction
  navigateTo?: string;
  className?: string;
  target?: string;
  onClick?: () => void;
  variant?: "bordered";
};

export const PrimaryButton = ({
  text,
  translationKey = "primaryButton.text", // Valeur par défaut
  navigateTo,
  className = "",
  target = "_self",
  onClick,
  variant,
}: PrimaryButtonProps) => {
  const t = useTranslations();

  // Utilise le texte fourni ou la traduction
  const buttonText = text || t(translationKey);

  const buttonClasses = `
    bg-secondary text-primary rounded-lg p-[12px]
    transition-all duration-300 ease-in-out
    group relative overflow-hidden
    ${variant === "bordered" ? "border border-primary/30" : ""}
    ${className}
  `;

  const content = (
    <>
      <Icon
        icon="mdi:play"
        className="absolute left-3 top-1/2 -translate-x-2 -translate-y-1/2 transform opacity-0 transition-all duration-300 ease-in-out group-hover:translate-x-0 group-hover:opacity-100"
      />
      <span className="transition-all duration-300 ease-in-out group-hover:ml-6">
        {buttonText}
      </span>
    </>
  );

  if (navigateTo) {
    return (
      <Link
        href={navigateTo}
        className={buttonClasses}
        target={target}
        rel={target === "_blank" ? "noopener noreferrer" : undefined}
        onClick={onClick}
      >
        {content}
      </Link>
    );
  }

  return (
    <button className={buttonClasses} onClick={onClick}>
      {content}
    </button>
  );
};
